export default __webpack_public_path__ + "static/media/isa4.83422197.jpg";